import React, { useState } from 'react';
import { Box, Typography, Link, List, ListItem, ListItemText, Divider } from '@mui/material';
import { Fade } from '@mui/material';

// Define a type for a topic if not already defined
interface Topic {
  category: string;
  emoji: string;
  description: string;
  links: { name: string; url: string; emoji: string }[];
}

const TopicBox: React.FC<{ topic: Topic }> = ({ topic }) => {
  const [hoveredLinkTitle, setHoveredLinkTitle] = useState<string>('');
  return (
    <Box sx={{ width: '300px', padding: 3, border: '1px solid #ddd', borderRadius: '8px', boxShadow: 3 }}>
      <Fade in={true} timeout={2000}>
        <Typography variant="h2" sx={{ fontSize: '1.8rem', marginBottom: 2 }}>
          {topic.category} {topic.emoji}
        </Typography>
      </Fade>
      <Typography variant="body2" sx={{ marginBottom: 2, color: '#555' }}>
        {topic.description}
      </Typography>
      <List>
        {topic.links.map((link) => (
            <ListItem
            key={link.name}
            sx={{ padding: 0 }}
            onMouseEnter={() => setHoveredLinkTitle(link.tooltip || '')}
            onMouseLeave={() => setHoveredLinkTitle('')}
            >
            <ListItemText
                primary={
                <Link href={link.url} target="_blank" sx={{ color: '#007BFF', textDecoration: 'none' }}>
                    {link.name} {link.emoji}
                </Link>
                }
            />
            </ListItem>
        ))}
        </List>


      <Divider sx={{ margin: '12px 0' }} />
      {hoveredLinkTitle && (
        <Typography variant="body2" sx={{ color: '#007BFF' }}>
          {hoveredLinkTitle}
        </Typography>
      )}
    </Box>
  );
};

export default TopicBox;